// extracted by mini-css-extract-plugin
export default {"loadingContainer":"tenantBasicInfo_loadingContainer__aXIE-","container":"tenantBasicInfo_container__+mEzJ","section":"tenantBasicInfo_section__XlZBF"};